import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '@application/config';
import { TPersonModule } from '../entities/system-modules.model';

@Injectable({ providedIn: 'root' })
export class SystemModulesService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(APP_CONFIG).apiUrl.subscription_service;

  public getPersonModules(): Observable<TPersonModule[]> {
    return this.http.get<TPersonModule[]>(`${this.apiUrl}/Person/products/module`, { 
      withCredentials: true 
    });
  }
}

